export function GetLocalStroge(fieldName) {
  let temp;
  try {
    temp = JSON.parse(localStorage.getItem(fieldName));
  } catch (e) {
    temp = localStorage.getItem(fieldName);
  }
  return temp || {};
}
/**
 * @description set localstorage data by field name
 * @param fieldName string
 */
export function SetLocalStroge(fieldName: string, value: string | object) {
  switch (typeof value) {
    case 'object':
      const oldData = GetLocalStroge(fieldName);
      localStorage.setItem(fieldName, JSON.stringify({ ...oldData, ...value }));
      break;
    default:
      localStorage.setItem(fieldName, value);
      break;
  }
}
/**
 * @description remove localstorage data by field name
 * @param fieldName string
 */
export function RemoveLocalStroge(fieldName): void {
  localStorage.removeItem(fieldName);
}
/**
 * @description remove localstorage data by field name
 * @param fieldName string
 */
export function ClearLocalStroge(): void {
  localStorage.clear();
}
